// Import the submodule directly: the package entry re-exports React components,
// which tree-shaking fails to drop and pulls React into this bundle.
import { logout as logoutImpl } from '@ok/okj-common/lib/logout/logout';

import utils from '@common/utils';

// 登出
export default function logout() {
  logoutImpl()
    .then(() => {
      window.location.href = utils.getLoginUrl();
    })
    .catch(undefined);
}
